import React from "react";
import { useHistory } from "react-router-dom";
import { Button, useNotify } from "ebs-design";
import { useMutation, useQueryClient } from "react-query";

import { useModalState, useAuth } from "@aeo/core/hooks";
import models from "@aeo/core/models";
import { notifyErrors } from "@aeo/core/utils";

import api, { querykeys } from "api";
import { WarningModal } from ".";

export interface AEOInfoModalTriggerProps {
  type: models.AEOType;
}

export const AEOInfoModalTrigger = ({ type }: AEOInfoModalTriggerProps) => {
  const warningModal = useModalState();
  const queryClient = useQueryClient();
  const notify = useNotify();
  const history = useHistory();
  const { user, refetchProfile } = useAuth();

  const activeApp = user?.organization?.active_application;

  const appIsNotAEOF =
    activeApp?.type && activeApp?.type !== models.AEOType.AEOF;

  const typeIsAEOF = type === models.AEOType.AEOF;

  const createUpgradeDraftMutation = useMutation(
    () => api.application.createDraft(type, activeApp?.id),
    {
      onSuccess: async () => {
        await refetchProfile();
        queryClient.invalidateQueries(querykeys.applications.many());
        history.push("/application");
      },
      onError: (error) => notifyErrors(notify, error),
    },
  );

  const handleButtonClick = () => {
    if (typeIsAEOF) {
      if (!activeApp?.id) {
        notify.error({
          title: "Eroare",
          description: "Nu există o cerere activă pentru a iniția schimbarea tipului.",
        });
        return;
      }
      createUpgradeDraftMutation.mutate();
    } else {
      warningModal.open();
    }
  };

  return (
    <>
      {appIsNotAEOF && (
        <Button
          type="ghost"
          onClick={handleButtonClick}
          disabled={createUpgradeDraftMutation.isLoading}
          className="view-authorization__change-status-btn ml-8 mr-8 mb-10"
        >
          {createUpgradeDraftMutation.isLoading
            ? "Se creează..."
            : `Completeaza cererea pentru ${type}`}
        </Button>
      )}
      <WarningModal
        open={warningModal.isOpen}
        onClose={warningModal.close}
        size="small"
        type={type}
      />
    </>
  );
};
